module.exports = __webpack_public_path__ + "static/img/loginrnd.3392ff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/loginrnd.png
// module id = 109
// module chunks = 0